{
  "#AI_AGENT": {
    "TITLE": "AI Agent",
    "CHAT_PAGE_TITLE": "AI Agent – Chat",
    "PANEL_TITLE": "AI Agent",
    "PLACEHOLDER": "Ask about sales statistics…",
    "SEND": "Send",
    "THINKING": "Thinking…",
    "TOOL_RUNNING": "Querying statistics:",
    "TOOL_CLIENT_RUNNING": "Running:",
    "NEW_CONVERSATION": "New conversation",
    "EMPTY": "Ask a question about sales statistics.",
    "ERROR": "Error:",
    "HOP_LIMIT": "Too many consecutive actions — the request was stopped.",
    "CONTEXT_CHIPS": "Context",
    "MENTION_PICK_ENTITY": "Pick a masterdata type",
    "CHART": "Chart",
    "TABLE": "Table",
    "MENTION_CLOSE": "Close search"
  }
}
